import { TFunction } from 'next-i18next'

import { getSelectedColorFromSelectedOptions } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productDynamicDataStateManager from '@src/quince-site-common/src/redux/globalStateManager/productDynamicDataStateManager/ProductDynamicDataStateManager'
import { isLoggedIn } from '@src/quince-site-integrated/src/utils'
import { FINDING_METHOD_AGGREGATE, setFindingMethod } from '@src/telemetry/findingMethod'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import { getColorwayId } from '@src/telemetry/integrations/provider-utils/stylitics-utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
type ImpressionCallback = (eventDataObj: any, index: number) => void
export const STYLITICS_CONFIG = {
  CLIENT: 'quince',
  TARGET: 'stylitics-composer-container',
  MODULE_TYPE: 'hotspots',
  PLACEMENT: 'pdp',
} as const

export const StyliticsTrackingConfig = {
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerDisplayName: 'Complete the Look - Stylitics',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerName: 'Single Swimlane',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerType: 'Product Display',
  tracking_id: 'complete_the_look_stylitics',
}
export const StyliticsModalTrackingConfig = {
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerDisplayName: 'Complete the Look - Stylitics',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerName: 'Single Swimlane',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerType: 'Product Display',
  tracking_id: 'complete_the_look_stylitics_modal',
}

export const StyliticsJumplinkTrackingConfig = {
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerDisplayName: 'Product Overview',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerName: 'Product Gallery',
  //eslint-disable-next-line i18next/no-literal-string
  contentContainerType: 'Product Overview',
  tracking_id: 'complete_the_look_stylitics',
}
export function trackImpressions(
  container: HTMLElement,
  onImpression: ImpressionCallback,
  options: IntersectionObserverInit = {},
  eventDataObj: any,
) {
  if (!container) return

  const items = Array.from(container.children)

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target
          const index = items.indexOf(target)
          onImpression(eventDataObj, index)

          obs.unobserve(target)
        }
      })
    },
    {
      root: null,
      // eslint-disable-next-line i18next/no-literal-string
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.5,
      ...options,
    },
  )

  items.forEach(el => {
    observer.observe(el)
  })

  return () => {
    observer.disconnect()
  }
}
export const handleItemClick = (item: any, action?: string, location?: string) => {
  trackEvent(TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_CLICK, {
    itemObject: item,
    // eslint-disable-next-line i18next/no-literal-string
    placement: 'main',
    position: item.index,
  })
  trackStyliticsItemClick(item, action, location)
}
export const handleItemView = (eventDataObj: any, index: number) => {
  trackEvent(TELEMETRY_EVENT_NAMES.STYLITICS_ITEM_VIEW, {
    itemObject: eventDataObj.items[index],
    // eslint-disable-next-line i18next/no-literal-string
    itemImageType: 'laydown',
    position: index,
  })
}

export const appendShopTheModelBadge = (data: any, isMobile?: boolean) => {
  const bundle = data.bundle
  const element = data.element

  if (bundle['on-model-image']) {
    if (isMobile) {
      element.querySelector('.stylitics-ui-card-cta').innerHTML = `<span>SHOP THE MODEL</span>`
    } else {
      const badge = document.createElement('img')
      badge.setAttribute('src', '/static-assets/shopTheModel.svg')
      badge.setAttribute('type', 'image/svg+xml')
      badge.setAttribute('class', 'shop-the-model')
      badge.setAttribute('aria-label', "This outfit corresponds with model's on product image")
      element.querySelector('.stylitics-bundle-badge').appendChild(badge)
    }
  }
}

export const getItems = (outfit: any) => {
  return outfit?.items?.map((item: any) => {
    return {
      product_id: item.product_id,
      title: item.name,
      color: item.retailer_color,
    }
  })
}
export const trackStyliticsCardClick = (productProperties: ProductProperties, outfit: any) => {
  try {
    trackEvent(TELEMETRY_EVENT_NAMES.STYLITICS_CTL_CLICK, {
      action: 'click_complete_the_look_stylitics',
      //eslint-disable-next-line i18next/no-literal-string
      entity_type: 'action',
      context: {
        ...StyliticsTrackingConfig,
        productProperties: productProperties,
        items: getItems(outfit),
      },
    })
  } catch (error) {
    console.error('Error tracking stylitics ctl click', error)
  }
}

export const trackStyliticsItemClick = (item: any, action?: string, location?: string) => {
  setFindingMethod[FINDING_METHOD_AGGREGATE.RECOMMENDATION]?.({
    //eslint-disable-next-line i18next/no-literal-string
    elementName: 'Single Swimlane',
    elementId: location === 'modal' ? 'complete_the_look_stylitics_modal' : 'complete_the_look_stylitics',
  })
  const productProperties = {
    product_id: item.product_id,
    title: item.name,
    color: item.retailer_color,
    position: Number(item.index ?? 0) + 1,
  }
  trackEvent(TELEMETRY_EVENT_NAMES.PRODUCT_CLICK, {
    action: action ?? 'click_complete_the_look_stylitics',
    //eslint-disable-next-line i18next/no-literal-string
    entity_type: 'action',
    context: {
      ...StyliticsTrackingConfig,
      productProperties: productProperties,
      contentContainerDisplayName:
        location === 'modal'
          ? //eslint-disable-next-line i18next/no-literal-string
            'Complete the Look - Stylitics - Modal'
          : StyliticsTrackingConfig.contentContainerDisplayName,
      tracking_id: action ?? 'complete_the_look_stylitics',
    },
  })
}

export const initializeStyliticsComposer = async ({
  selectedColor,
  itemNumber,
  overrideOnClick,
  setAllOutfitsData,
  setIsStyliticsDataPresent,
  setIsStyliticsLoading,
  lbUserId,
  t,
  isMobile,
  productProperties,
}: {
  selectedColor?: string
  itemNumber: string
  overrideOnClick: (e: any) => void
  setAllOutfitsData: (data: any) => void
  setIsStyliticsDataPresent: (data: any) => void
  setIsStyliticsLoading: (loading: boolean) => void
  lbUserId?: string
  t: TFunction
  isMobile?: boolean
  productProperties: ProductProperties
}) => {
  const el = document.getElementById(STYLITICS_CONFIG.TARGET)
  if (el) {
    el.replaceChildren()
  }
  if (!selectedColor) {
    setIsStyliticsLoading(false)
    return
  }
  const composer = await window.StyliticsComposer?.initialize({
    client: STYLITICS_CONFIG.CLIENT,
    target: STYLITICS_CONFIG.TARGET,
    config: {
      modules: [
        {
          type: STYLITICS_CONFIG.MODULE_TYPE,
          params: {
            api: {
              item_number: itemNumber,
              min: 3,
              max: 10,
            },
            display: {
              desktopHorizontalScroll: false,
            },
            responsive: [
              [0, { columns: 1 }],
              [850, { columns: 3 }],
            ],
          },
        },
      ],
      override: {
        'click.outfit': function (e: any) {
          trackStyliticsCardClick(productProperties, e.outfit)
          overrideOnClick(e)
        },
      },
      on: {
        'load.data': function (e: any) {
          setAllOutfitsData(e.outfits)
          if (e.outfits?.length > 2) {
            setIsStyliticsDataPresent(true)
            productDynamicDataStateManager.setProductHasStyliticsData(itemNumber, true)
          } else {
            setIsStyliticsDataPresent(false)
            productDynamicDataStateManager.setProductHasStyliticsData(itemNumber, false)
          }
          setIsStyliticsLoading(false)
        },
        'mount.bundle': function (data: any) {
          appendShopTheModelBadge(data, isMobile)
        },
        'click.item': function (e: any) {
          trackStyliticsItemClick(e.item)
        },
      },

      sharedParams: {
        customer: {
          clientUserId: isLoggedIn() ? lbUserId : '',
        },
        analytics: {
          placement: STYLITICS_CONFIG.PLACEMENT,
        },
        text: {
          viewDetailsCTA: t('shop_the_look'),
        },
      },
    },
  })
  await composer?.start()
  await composer?.refresh({
    modules: [
      {
        type: STYLITICS_CONFIG.MODULE_TYPE,
        params: {
          api: {
            item_number: itemNumber,
          },
        },
      },
    ],
  })
  return composer
}

export const trackStyliticsModalImpressions = (productProperties: ProductProperties, items: any) => {
  try {
    trackEvent(TELEMETRY_EVENT_NAMES.IS_VISIBLE, {
      action: 'visible_product_list',
      //eslint-disable-next-line i18next/no-literal-string
      entity_type: 'product_card_view',
      context: {
        ...StyliticsModalTrackingConfig,
        productProperties: productProperties,
        items: getItems({ items }),
      },
    })
  } catch (error) {
    console.error('Error tracking stylitics modal impressions', error)
  }
}

export const trackStyliticsWidgetImpressions = (
  styliticsWidgetRef: React.RefObject<HTMLDivElement>,
  allOutfitsData: any,
  productProperties: ProductProperties,
) => {
  const items = allOutfitsData.map((outfit: any) => outfit.items)
  const trackWidgetImpressions = () => {
    trackEvent(TELEMETRY_EVENT_NAMES.IS_VISIBLE, {
      action: 'visible_product_list',
      //eslint-disable-next-line i18next/no-literal-string
      entity_type: 'product_card_view',
      context: {
        ...StyliticsTrackingConfig,
        productProperties: productProperties,
        items: items.map((outfit: any) => getItems({ items: outfit })),
      },
    })
  }
  if (styliticsWidgetRef.current) {
    trackImpressions(styliticsWidgetRef.current, trackWidgetImpressions, {}, {})
  }
}

export const refreshStylitics = async (product: Product | undefined, selectedOptions: ProductVariantOption[]) => {
  if (!product || !window?.StyliticsInsights) {
    return
  }
  await window.StyliticsInsights.refresh({
    itemId: getColorwayId(product?.spid?.toString(), getSelectedColorFromSelectedOptions(selectedOptions)),
  })
}
